export const sortByIds = (ids: string[], a: { id: string }, b: typeof a) =>
  ids.map(Number).indexOf(Number(a.id)) - ids.map(Number).indexOf(Number(b.id))
